import React, { createContext, useContext, useMemo } from 'react';
import type { MessageClass, ToolPart } from '@cotera/sdk/core';
import {
  collectLatestArtifactToolCallIds,
  getArtifactInlineDisplayMode,
  shouldShowInlineArtifactSnippet,
  type ArtifactInlineDisplayMode,
} from './artifact-inline-dedupe';

type ArtifactInlineDedupeContextValue = ReadonlyMap<string, string>;

const ArtifactInlineDedupeContext =
  createContext<ArtifactInlineDedupeContextValue | null>(null);

export const ArtifactInlineDedupeProvider: React.FC<{
  messages: readonly MessageClass[];
  children: React.ReactNode;
}> = ({ messages, children }) => {
  const latestByArtifactId = useMemo(
    () => collectLatestArtifactToolCallIds(messages),
    [messages]
  );

  return (
    <ArtifactInlineDedupeContext.Provider value={latestByArtifactId}>
      {children}
    </ArtifactInlineDedupeContext.Provider>
  );
};

export function useShouldShowInlineArtifactSnippet(part: ToolPart): boolean {
  const latestByArtifactId = useContext(ArtifactInlineDedupeContext);
  if (latestByArtifactId === null) {
    return true;
  }
  return shouldShowInlineArtifactSnippet(part, latestByArtifactId);
}

export function useArtifactInlineDisplayMode(
  part: ToolPart
): ArtifactInlineDisplayMode {
  const latestByArtifactId = useContext(ArtifactInlineDedupeContext);
  return getArtifactInlineDisplayMode(part, latestByArtifactId);
}
